// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__2bhYs","overlay":"modal_overlay__3GC-N","content":"modal_content__1tL7m","dialog":"modal_dialog__2O8hE"};